import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=ed95eb38"
import script from "./Pagina.vue?vue&type=script&lang=js"
export * from "./Pagina.vue?vue&type=script&lang=js"
import style0 from "./Pagina.vue?vue&type=style&index=0&id=ed95eb38&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports